import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { applyUpdate } from "@/pwa/register-sw";

export const UpdatePrompt = () => {
  const shown = useRef(false);
  useEffect(() => {
    const onUpd = (e) => {
      if (shown.current) return;
      shown.current = true;
      toast("Aggiornamento disponibile", {
        description: "È disponibile una nuova versione di K9 Manager.",
        duration: Infinity,
        action: { label: "Aggiorna", onClick: () => applyUpdate(e.detail) },
        cancel: { label: "Più tardi" },
        onDismiss: () => { shown.current = false; },
        onAutoClose: () => { shown.current = false; },
      });
    };
    window.addEventListener("k9swupdate", onUpd);
    return () => window.removeEventListener("k9swupdate", onUpd);
  }, []);
  return null;
};
